export enum StatusCodeConstants {
  info = "info",
  ok = "ok",
  redirect = "redirect",
  error = "error"
}